let Api = {
    // "N_TESTAGENCYMANAGE_FINDLIST" : + "xmfk/n/TestingAgencyManage/findList",//查询机构禁用列表
    'N_ORGUSERLISTGROUP': '/mdb/n/orgUserListGroup',//产品管理分页列表
     "MDB_SELORGLIST1" : "/mdb/n/selOrgListNew",//查询列表
     
      "MDB_N_SELORGLIST" : "/mdb/n/selOrgList",//查询列表
      "N_GEO_PAGE_LIST" : "/dc/n/protal/pGeo/pageList",//查询列表
      "N_GEO_GET" : "/dc/n/protal/pGeo/get",//查询详情列表
}
module.exports = Api